import { DriverOptionsInput } from '@allocab/allocab-driver-shared-types';
import { useMutation } from '@tanstack/react-query';

import { DriverOptionOutput } from './types';
import { mutationKeys } from '../services/datastore/mutationKeys';
import { queryKeys } from '../services/datastore/queryKeys';
import { queryClient, queryErrorHandler } from '../services/datastore/react-query';
import { driverApi } from '../services/network/Api';

const queryKey = queryKeys.user.fetchDriverOptions();

const patchDriverOptions = (input: DriverOptionsInput) =>
  driverApi.patch<DriverOptionsInput, DriverOptionOutput>('/v1/driver/options', input);

const usePatchDriverOptions = () =>
  useMutation<
    DriverOptionOutput,
    unknown,
    DriverOptionsInput,
    { previousOptions: DriverOptionOutput | undefined; newOptions: DriverOptionOutput }
  >({
    mutationKey: mutationKeys.user.patchDriverOptions(),
    mutationFn: patchDriverOptions,
    onMutate: async input => {
      await queryClient.cancelQueries(queryKey);

      const previousOptions = queryClient.getQueryData<DriverOptionOutput>(queryKey);
      const newOptions: DriverOptionOutput = {
        seePriceWithCommission: input.seePriceWithCommission ?? previousOptions?.seePriceWithCommission ?? false,
      };

      queryClient.setQueryData(queryKey, newOptions);

      return { previousOptions, newOptions };
    },
    onError: (error, _input, context) => {
      queryClient.setQueryData(queryKey, context?.previousOptions);
      queryErrorHandler(error);
    },
    onSettled: () => {
      queryClient.invalidateQueries(queryKey);
    },
  });

export default usePatchDriverOptions;
